import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { ToolContext } from "../fluent/hoc/fluentToolWrapper";
import { Pane } from "../fluent/hoc/pane";
import { Accordion } from "../fluent/primitives/accordion";
/**
 * A wrapper component for the property tab that provides a consistent layout and styling.
 * It uses a Pane and an Accordion to organize the content, so its direct children
 * must have 'title' props to be compatible with the Accordion structure.
 * @param props The props to pass to the component.
 * @returns The rendered component.
 */
export const PropertyTabComponentBase = (props) => {
    const context = useContext(ToolContext);
    if (context.useFluent) {
        return (_jsx(Pane, { title: context.toolName, children: _jsx(Accordion, { children: props.children }) }));
    }
    return (_jsxs("div", { id: "propertyTab", children: [_jsxs("div", { id: "header", children: [_jsx("img", { id: "logo", src: "https://www.babylonjs.com/Assets/logo-babylonjs-social-twitter.png" }), _jsx("div", { id: "title", children: context.toolName })] }), _jsx("div", { children: props.children })] }));
};
//# sourceMappingURL=propertyTabComponentBase.js.map